import React, { useContext } from 'react';
import { EDAutoCompleteEdit } from '../../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import EDAvenyProgress from '../../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import {
  IBusinessCollectionProps,
  IObjektVy,
  IObjektVyComp,
} from '../../../../../../../Types/ObjektVy';
import { BusinessDataFormContext } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { BokforderSettingsQuery_db_EKBokforingsmall_All } from '../../Queries/BokforderSettingsQuery/_QueryTypes/BokforderSettingsQuery';

import BokforderContext from '../BokforderContext/BokforderContext';
interface IProps extends IBusinessCollectionProps {
  choosenTemplate?: BokforderSettingsQuery_db_EKBokforingsmall_All | null;
  setChoosenTemplate?: React.Dispatch<
    React.SetStateAction<BokforderSettingsQuery_db_EKBokforingsmall_All | null>
  >;
  skipAreYouSureDialog?: boolean;
}

const BokforderTemplateComp: IObjektVyComp = {
  caption: '',
  comp: (props: IProps) => <BokforderTemplateView {...props} />,
};

export const BokforderTemplateView: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const formContext = useContext(BusinessDataFormContext);
  const bokforderContext = useContext(BokforderContext);

  const onValueChange = (
    option: BokforderSettingsQuery_db_EKBokforingsmall_All | null
  ) => {
    props?.setChoosenTemplate
      ? props.setChoosenTemplate(option)
      : bokforderContext.onTemplateChange(option);
  };

  return (
    <>
      {bokforderContext.templates.length === 0 ? (
        <EDAvenyProgress />
      ) : bokforderContext.isEditMode ? (
        <EDAutoCompleteEdit<BokforderSettingsQuery_db_EKBokforingsmall_All>
          disabled={
            !bokforderContext.isEditMode || formContext?.formState.loading
          }
          fullWidth
          getOptionLabel={option => {
            return option.BENAMNING ?? 'Mallens namn kunde inte hittas';
          }}
          getOptionSelected={(option, value) => {
            return option.id === value?.id;
          }}
          disableOpenOnFocus
          label="Välj Mall"
          onChange={option => {
            if (!Array.isArray(option)) {
              if (
                formContext?.formState.formHasChanged &&
                !props?.skipAreYouSureDialog
              ) {
                bokforderContext.setAreYouSureModalOpen(true);
                bokforderContext.setAreYouSureModalCallback({
                  callback: () => {
                    onValueChange(option);
                  },
                });
              } else {
                onValueChange(option);
              }
            }
          }}
          options={bokforderContext.templates.filter(
            template => template.AKTIV
          )}
          inputMargin="dense"
          value={
            props?.choosenTemplate === undefined
              ? bokforderContext.currentTemplate
              : props.choosenTemplate
          }
          testId="skapaDialogMall"
        />
      ) : (
        <EDTypography>
          <EDTypography bold>Mall:</EDTypography>{' '}
          {bokforderContext.currentTemplate?.BENAMNING}
        </EDTypography>
      )}
    </>
  );
};

export const BokforderTemplate: IObjektVy = {
  type: 'ObjektVy',
  id: 'BokforderTemplate',
  info: {},
  def: () => BokforderTemplateComp,
};
